
import { Link } from "react-router-dom";

const options = [
  { icon: "🏟️", title: "Ground Booking", text: "Book our cricket ground for practice, matches and events.", path: "/ground-booking" },
  { icon: "🏏", title: "Academy Booking", text: "Join Hunters Cricket Academy and enquire about coaching.", path: "/academy-booking" },
  { icon: "🏆", title: "Tournament Registration", text: "Register your team or player for upcoming tournaments.", path: "/tournament-registration" },
  { icon: "📩", title: "Contact Enquiries", text: "Send an enquiry to the Hunters Cricket Academy team.", path: "/contact-enquiry" }
];

export default function Booking() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-navy to-white">
      
      <main className="pt-32 pb-16 px-5">
        <div className="max-w-6xl mx-auto">
          <div className="text-center text-white mb-12">
            <p className="uppercase tracking-[0.3em] text-white/70 font-semibold">Hunters Cricket Academy</p>
            <h1 className="text-4xl md:text-6xl font-extrabold mt-3">Booking & Registration</h1>
            <p className="mt-4 text-white/80 max-w-2xl mx-auto">Choose a service below. Each card opens its own dedicated page.</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {options.map((item) => (
              <Link key={item.path} to={item.path} className="group bg-white rounded-3xl p-7 shadow-2xl hover:-translate-y-2 transition-all duration-300">
                <div className="w-16 h-16 rounded-2xl bg-navy text-white flex items-center justify-center text-3xl shadow-lg group-hover:scale-110 transition">
                  {item.icon}
                </div>
                <h2 className="text-xl font-extrabold text-navy mt-6">{item.title}</h2>
                <p className="text-gray-600 mt-3 leading-relaxed">{item.text}</p>
                <div className="mt-6 font-bold text-gold">Open page →</div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
